module.exports = __webpack_public_path__ + "static/media/tm.383a04ae.svg";